import { ProductFieldsFragment } from '../../graphql';

export const filterVisibleProducts =
	(store?: number, region?: number) =>
	(product: ProductFieldsFragment): boolean => {
		const sortedVisibility = product.visibility
			.slice()
			.sort((a, b) => a.storeId - b.storeId || a.regionId - b.regionId);
		let isVisible = true;

		if (sortedVisibility.length > 0) {
			isVisible = false;

			{
				const [
					{ storeId, regionId, isVisibleOnlineOrdering: visible }
				] = sortedVisibility;
				if (storeId === 0 && regionId === 0) {
					isVisible = visible;
				}
			}

			for (const {
				storeId,
				regionId,
				isVisibleOnlineOrdering: visible
			} of sortedVisibility) {
				if (regionId === region && storeId === 0) {
					isVisible = visible;
					break;
				}
			}

			for (const {
				storeId,
				regionId,
				isVisibleOnlineOrdering: visible
			} of sortedVisibility) {
				if (storeId === store && regionId === 0) {
					isVisible = visible;
					break;
				}
			}
		}

		return isVisible;
	};
